module.exports = __webpack_public_path__ + "img/fuli_en_ID_img2.9d343c4f.png";